export default {
  namespaced: true,
  state: {
    formCustomer: {
      firstName: '',
      lastName: '',
      cellPhone: '',
      cpf: '',
      birthDate: '',
      email: '',
      contactPreference: 'sms',
      gender: null,
      maritalStatus: null,
      password: '',
      passwordConfirmation: '',
    },
    code: '',
    codeConfirmation: '',
    isTermoUso: false,
    isPoliticaPrivacidade: false,
  },
  getters: {
    getFirstName: state => state.formCustomer.firstName,
    getLastName: state => state.formCustomer.lastName,
    getCellPhone: state => state.formCustomer.cellPhone,
    getCpf: state => state.formCustomer.cpf,
    getBirthDate: state => state.formCustomer.birthDate,
    getEmail: state => state.formCustomer.email,
    getContactPreference: state => state.formCustomer.contactPreference,
    getMaritalStatus: state => state.formCustomer.maritalStatus,
    getGender: state => state.formCustomer.gender,
    getPassword: state => state.formCustomer.password,
    getPasswordConfirmation: state => state.formCustomer.passwordConfirmation,
    getCodeConfirmation: state => state.codeConfirmation,
    getIsTermoUso: state => state.isTermoUso,
    getIsPoliticaPrivacidade: state => state.isPoliticaPrivacidade,
    getCode: state => state.code,
    getFormCustomer: state => state.formCustomer,
  },
  mutations: {
    SET_FIRST_NAME: (state, payload) => {
      state.formCustomer.firstName = payload
    },
    SET_LAST_NAME: (state, payload) => {
      state.formCustomer.lastName = payload
    },
    SET_CELL_PHONE: (state, payload) => {
      state.formCustomer.cellPhone = payload
    },
    SET_CPF: (state, payload) => {
      state.formCustomer.cpf = payload
    },
    SET_BIRTH_DATE: (state, payload) => {
      state.formCustomer.birthDate = payload
    },
    SET_EMAIL: (state, payload) => {
      state.formCustomer.email = payload
    },

    SET_CONTACT_PREFERENCE: (state, payload) => {
      state.formCustomer.contactPreference = payload
    },

    SET_MARITAL_STATUS: (state, payload) => {
      state.formCustomer.maritalStatus = payload
    },

    SET_GENDER: (state, payload) => {
      state.formCustomer.gender = payload
    },

    SET_PASSWORD: (state, payload) => {
      state.formCustomer.password = payload
    },
    SET_PASSWORD_CONFIRMATION: (state, payload) => {
      state.formCustomer.passwordConfirmation = payload
    },
    SET_CODE_CONFIRMATION: (state, payload) => {
      state.codeConfirmation = payload
    },
    SET_IS_TERMO_USO: (state, payload) => {
      state.isTermoUso = payload
    },
    SET_IS_POLITICA_PRIVACIDADE: (state, payload) => {
      state.isPoliticaPrivacidade = payload
    },
    SET_CODE: (state, payload) => {
      state.code = payload
    },
    SET_CLEAR_FORM: state => {
      state.formCustomer = {
        firstName: '',
        lastName: '',
        cellPhone: '',
        cpf: '',
        birthDate: '',
        email: '',
        contactPreference: '',
        gender: '',
        password: '',
        passwordConfirmation: '',
      }
      state.code = ''
      state.codeConfirmation = ''
      state.isTermoUso = false
      state.isPoliticaPrivacidade = false
    },
  },
  actions: {},
}
